export enum UserToEntityRelationVisibilityEnum {
	Shown = '0ad94724-258b-46f8-98df-d6b91a69947c',
	Hidden = '34896d74-20cd-4fee-9411-5bd7eb738789'
}
